import { cn } from '@shared/lib/utils';
import { CopyFeedbackIcon } from '@shared/ui/copy-feedback-icon';

interface CopyIconButtonProps {
  copied?: boolean;
  onClick: () => void;
  label: string;
  className?: string;
  iconClassName?: string;
}

export function CopyIconButton({
  copied,
  onClick,
  label,
  className,
  iconClassName = 'size-5',
}: CopyIconButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-sm text-foreground',
        'size-5',
        'transition-colors duration-fast ease-standard hover:opacity-70',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        className
      )}
    >
      <CopyFeedbackIcon copied={copied} className={cn(iconClassName, copied && 'text-emerald-500')} />
    </button>
  );
}
